import React from 'react';

import styles from './index.module.scss';

const Loading: React.FC = () => {
  return (
        <div className={styles.container}>
            <div className={styles.circularProgress}>
                <svg viewBox="22 22 44 44">
                    <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6" />
                </svg>
            </div>
        </div>
  );
};

export default Loading;
